import React from 'react';
import PopUp from '../../../../components/common/PopUp/PopUp';
import { 
  testOfChangeDescHelperTextContent, 
  testOfChangeHelperTextContent, 
  testOfChangeOutComeHelperTextContent, 
  testOfRatingHelperTextContent 
} from '../ProjectHelper/ProjectDetailsHelperText';

export interface DisplayTestOfChangeProps {
  rows: any[];
  selectedIndex: number;
}

const DisplayTestOfChange: React.FC<DisplayTestOfChangeProps> = ({ rows, selectedIndex }) => {
  const item = rows[selectedIndex] ?? {};
  return (
    <div>
      <div className="h-[60px] bg-[#003B71]! flex items-center px-4!">
        <p className="p2 text-white!"><strong>Test of Change details: </strong></p>
      </div>
      <div className="min-h-[76px] p-[14px]! border-l-[1px] border-l-[#E9EBEE] border-r-[1px] border-r-[#E9EBEE] border-b-[1px] border-b-[#878F9B] border-t-0 border-solid">
        <p className="p3 m-[0px]!"><strong>Test of change title </strong><PopUp message={testOfChangeHelperTextContent} /></p>
        <p className="p3 m-[0px]!">{item?.testOfChangeTitle ?? ''}</p>
      </div>
      <div className="min-h-[76px] p-[14px]! border-l-[1px] border-l-[#E9EBEE] border-r-[1px] border-r-[#E9EBEE] border-b-[1px] border-b-[#878F9B] border-t-0 border-solid">
        <p className="p3 m-[0px]!"><strong>Test of change </strong><PopUp message={testOfChangeDescHelperTextContent} /></p>
        <p className="p3 m-[0px]! whitespace-pre-wrap">{item?.testOfChangeDesc ?? item?.testOfChange ?? ''}</p>
      </div>
      <div className="min-h-[76px] p-[14px]! border-l-[1px] border-l-[#E9EBEE] border-r-[1px] border-r-[#E9EBEE] border-b-[1px] border-b-[#878F9B] border-t-0 border-solid">
        <p className="p3 m-[0px]!"><strong>Outcome </strong><PopUp message={testOfChangeOutComeHelperTextContent} /></p>
        <p className="p3 m-[0px]! whitespace-pre-wrap">{item?.outcome ?? ''}</p>
      </div>
      <div className="min-h-[76px] p-[14px]! border-l-[1px] border-l-[#E9EBEE] border-r-[1px] border-r-[#E9EBEE] border-b-[1px] border-b-[#878F9B] border-t-0 border-solid">
        <p className="p3 m-[0px]!"><strong>Rating </strong><PopUp message={testOfRatingHelperTextContent} /></p>
        <p className="p3 m-[0px]!">{item?.ratingText ?? ''}</p>
      </div>
      <div className="min-h-[76px] p-[14px]! border-l-[1px] border-l-[#E9EBEE] border-r-[1px] border-r-[#E9EBEE] border-b-[1px] border-b-[#878F9B] border-t-0 border-solid">
        <p className="p3 m-[0px]!"><strong>Where did you get this idea? </strong></p>
        <p className="p3 m-[0px]!">
          {item?.testSourceId
            ? `${item.testSourceId} ${item.testSourceDesc ?? ''}`.trim()
            : (item?.testSourceDesc ?? '')}
        </p>
      </div>
    </div>
  );
};

export default DisplayTestOfChange;
